import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-contentPromotionVideoTypeShape",
  "use": "svg-icon-contentPromotionVideoTypeShape-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol viewBox=\"0 0 16 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-contentPromotionVideoTypeShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 5V3.34L11.629 5H9V2H2v8h6v2H1.5A1.5 1.5 0 0 1 0 10.5v-9A1.5 1.5 0 0 1 1.5 0h8A1.5 1.5 0 0 1 11 1.5V3L14.427.601a1 1 0 0 1 1.573.82V5h-2zm-1.103 1.31l3.02 3.184A.3.3 0 0 1 15.7 10h-1.302v3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V10h-1.302a.3.3 0 0 1-.217-.506l3.02-3.184z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol